import CryptoJS from 'crypto-js';
import { JSEncrypt } from 'jsencrypt';

// 问龙哥要 本地调试用 提交代码的时候删除掉
const PUBLIC_KEY = '';

const PRIVATE_KEY = '';

function randomString(e: any) {
  // eslint-disable-next-line no-param-reassign
  e = e || 32;
  let t = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ',
    a = t.length,
    n = '';
  for (let i = 0; i < e; i++) n += t.charAt(Math.floor(Math.random() * a));
  return n;
}

function getCryptoKey() {
  return randomString(16);
}

function encryptKey(key: string) {
  let encrypt = new JSEncrypt();
  encrypt.setPublicKey(PUBLIC_KEY);
  return encrypt.encrypt(key) || '';
}

function decryptKey(key: string) {
  let encrypt = new JSEncrypt();
  encrypt.setPrivateKey(PRIVATE_KEY);
  return encrypt.decrypt(key) || '';
}

// 加密
function aesEncrypt(plaintText: any, aesKey: string) {
  let options = {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  };
  let key = CryptoJS.enc.Utf8.parse(aesKey);
  let encryptedData = CryptoJS.AES.encrypt(plaintText, key, options);
  let encryptedBase64Str = encryptedData.toString();
  return encryptedBase64Str;
}

//解密
function aesDecrypt(encryptedBase64Str: any, aesKey: string) {
  let vals = encryptedBase64Str.replace(/-/g, '+').replace(/_/g, '/');
  let options = {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  };
  let key = CryptoJS.enc.Utf8.parse(aesKey);
  let decryptedData = CryptoJS.AES.decrypt(vals, key, options);
  let decryptedStr = CryptoJS.enc.Utf8.stringify(decryptedData);
  return decryptedStr;
}

export function encryptData(data: any) {
  try {
    const keyStr = getCryptoKey();
    const enData = aesEncrypt(JSON.stringify(data), keyStr);
    return {
      data: enData,
      encryptKey: encryptKey(keyStr),
    };
  } catch (e) {
    console.error(e);
    return false;
  }
}

export function decryptData(data: any, tmpKey: string) {
  try {
    if (!data || !tmpKey) {
      return false;
    }
    const keyStr = decryptKey(tmpKey);
    const resStr = aesDecrypt(data, keyStr);
    return JSON.parse(resStr || '{}');
  } catch (e) {
    console.error(e, 'eror');
    return false;
  }
}
